import React from "react";

import { Button, Grid, Image, Dropdown, Icon, Popup } from "semantic-ui-react";
import NoInfoImg from "./../../../images/grafix-banner/additional_att_board.png";
import SchemaModalForm from "./SchemaModalForm";


import { Form } from 'formsy-semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import * as Survey from "survey-react";
import * as widgets from "surveyjs-widgets";
class DisplaySurveySchema extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false, schema: []
        }


    }

    onSubmitSchema = (schema) => {
        this.props.onSubmitSchema(schema)
    }

    onRemoveItem = (e, item, data) => {
        let updateOptions =this.props.schema && this.props.schema.filter(
            option => option.name !== data.name
        );
        let message = <div className="confirmMessage">
            <h3>Delete Custom Attribute</h3>
            <label>{data.title}</label>
            <p>Are you sure to delete this custom attribute?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: async () => {
                this.props.onSubmitSchema(updateOptions)
            }
        });

    }

    schemaOpen = (open) => {
        this.setState({ open: open })
        this.setState({ selectedItem: null })
    }

    setItemToEdit = (e, item, data) => {
        console.log(data);
        this.setState({ selectedItem: data })
        setTimeout(() => {
            this.setState({ open: true })
        }, 100);
        console.log(this.state.selectedItem);
    }

    render() {
        let isMetaSchemaAvailable = this.props.schema && this.props.schema.length !== 0

        let noSchemaAvailable = <div className='display-block w_25'
            style={{
                display: "block", margin: '0 auto',
                textAlign: "center"
            }}>
            <Image src={NoInfoImg} style={{ margin: "0 auto" }} />
            <strong>Custom Attribute</strong>
            <p>You can add custom attribute here.<br />
                The custom attribute can be single/multi-line text,<br /> dropdown, checkbox, radio buttons etc  </p>
            {this.props.editAccess ?
                <Button className='button-info' onClick={() => this.schemaOpen(true)}>
                    Add
                </Button> : null}
        </div>

        let dataForSurveyFormObject = {}
        let jsn = {
            showNavigationButtons: false,
            completeText: this.props.buttonText ? this.props.buttonText : "Submit",
            questions: this.props.schema ? this.props.schema.map((elem) => {
                const elemCopy = {...elem}
                if(elem.type==="comment" || elem.type==="text")
                dataForSurveyFormObject[elem.name]=[elem.detail]
                if (elemCopy.isRestricted){
                    elemCopy.title = `${elemCopy.title} (Management Only)`
                }
                return elemCopy;
            }) : []
        }
        widgets.ckeditor(Survey);

        var model = new Survey.Model(jsn);

        model.data=dataForSurveyFormObject
        return (
            <div>

                <Grid className="PracticeCommunityPageGrid "
                    style={{
                        background: '#E2E9ED',
                        width: 'calc(100% - 40px)',
                        padding: '0 15px',
                        borderRadius: '4px',
                    }}>
                    <Grid.Row >
                        <div className="w_100 "
                            style={{
                                display: "block",
                                margin: '0 0 10px 0'
                            }}
                        >
                            {isMetaSchemaAvailable ?
                                this.props.editAccess ?
                                    <div>
                                        <strong style={{ margin: "7px 0" }} className=' float-left'>Preview</strong>
                                        <Button className='button-info float-right' onClick={() => this.schemaOpen(true)}>
                                            Add
                                        </Button>
                                    </div>
                                    : null : null}
                        </div>
                        {isMetaSchemaAvailable &&   this.props.editAccess ?
                            <Form className="formcyForm w_100 formbuilderForm"  >
                                <div className="pad_10 bg-white" style={{
                                    borderRadius: "5px",
                                    marginBottom: "10px",
                                    position: 'relative'
                                }} >
                                    <div

                                        className="transition-normal"
                                    >
                                        {this.props.editAccess ?
                                            <div style={{
                                                position: "absolute",
                                                right: "5px",
                                                top: "15px",
                                                lineHeight: "12px",
                                                fontSize: "12px",
                                                height: "16px",
                                            }}>
                                                <Dropdown
                                                    className="surveyDropdown"
                                                    icon='ellipsis vertical'
                                                    pointing="right">
                                                    <Dropdown.Menu>
                                                        {this.props.schema.map((comp, i) => {
                                                            return (<Dropdown.Item>
                                                                <b>{comp.title} <label className="clr-gray f_9">({comp.name})</label></b>
                                                                <Icon name="pencil" onClick={(e, data) => this.setItemToEdit(e, data, comp)} />
                                                                <Icon name="trash" onClick={(e, data) => this.onRemoveItem(e, data, comp)} />
                                                            </Dropdown.Item>)
                                                        })}
                                                    </Dropdown.Menu>
                                                </Dropdown> &nbsp; &nbsp;

                                            </div> : null}

                                        <Survey.Survey model={model} />
                                    </div>
                                </div>
                            </Form>



                            : noSchemaAvailable}
                    </Grid.Row>
                </Grid>
                {this.state.open &&
                    <SchemaModalForm
                        open={this.state.open}
                        close={this.close}
                        schemaOpen={this.schemaOpen}
                        onSubmitSchema={this.onSubmitSchema}
                        schema={this.props.schema}
                        selectedItem={this.state.selectedItem} />}

            </div>
        );
    }
}



export default withRouter(DisplaySurveySchema);



//     {this.props.schema.map((comp, i) => {

                                //         return (<div className="pad_10 bg-white" style={{
                                //             borderRadius: "5px",
                                //             marginBottom: "10px",
                                //             position: 'relative'
                                //         }} >
                                //             <div style={{
                                //                 position: "absolute",
                                //                 right: "5px",
                                //                 top: "15px",
                                //                 lineHeight: "12px",
                                //                 fontSize: "12px",
                                //                 height: "16px",
                                //             }}>
                                //                 {comp.detail &&
                                //                     <Popup
                                //                         trigger={<Icon style={{
                                //                             fontSize: "9px",
                                //                             verticalAlign: "text-bottom"
                                //                         }} circular inverted name='info' color="grey" />}
                                //                         content={comp.detail}
                                //                         className="popupStyled"
                                //                         position="bottom right"
                                //                         wide='very'
                                //                         style={{ padding: "10px 0" }}
                                //                         inverted
                                //                     />}

                                //                 {this.props.editAccess ?
                                //                     <Dropdown
                                //                         icon='ellipsis vertical'
                                //                         pointing="right">
                                //                         <Dropdown.Menu>
                                //                             <Dropdown.Item
                                //                                 text="Edit"
                                //                                 icon="pencil"
                                //                                 onClick={(e, data) => this.setItemToEdit(e, data, comp)}
                                //                             />
                                //                             <Dropdown.Item
                                //                                 text="Remove"
                                //                                 icon="trash"
                                //                                 onClick={(e, data) => this.onRemoveItem(e, data, comp)}
                                //                             />
                                //                         </Dropdown.Menu>
                                //                     </Dropdown> : null}
                                //             </div>
                                //             <div
                                //                 style={{ width: "calc(100% - 100px)" }}
                                //                 className="transition-normal"
                                //             >
                                //                 <Survey.Survey model={model} />
                                //             </div>

                                //         </div>

                                //         )
                                //     })}